import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSession } from "./SessionContext.js";

/**
 * Guard de ruta por módulo. `module` es la clave sin el prefijo "admin:"
 * (ej. "operaciones", "finanzas", "soporte", "plataforma", "analytics",
 * "dev-tools") — mismo namespace que usa el backend en `requirePermission`.
 */
export function RequireModuleAccess({ module }: { module: string }) {
  const { user, loading, can } = useSession();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!can(module)) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-zinc-950 p-6">
        <p className="text-sm text-red-400">No tenés acceso a este módulo.</p>
      </div>
    );
  }
  return <Outlet />;
}
